import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { StickyNavbar } from "./NavBar"
import { faCrown } from "@fortawesome/free-solid-svg-icons"

export function Pricing(){
    
    return(
        <div className="" >
            <StickyNavbar />
            <div  className="">
        <div className="row " style={{ backgroundColor: "", padding: "20px" }}>
        <div className="col mt-2 subcription_style" > 
        
        <div className="col header_bodaerstyle">
          <div className="silver_style">
            <FontAwesomeIcon icon={faCrown} color="black" size="100" />

          </div>
         
          <div className="sub_header">
            <h4>Silver Plan</h4>
            <h4>₹ 500</h4>
          </div>
          <div className="sub_header">
            <h6>One Month ,Desktop App</h6>
            <span style={{ textDecoration: 'line-through' }}>₹ 700</span>
          </div>
          <button onClick={()=>{
            window.open("https://rzp.io/i/wUoKq438",'_blank')
          }} className="silverbtn">Buy Silver</button>
          </div>
          <div className="cenert-border">
         <p className="pstyle">Your Custom Template </p>
         <p className="pstyle">Inventory Management </p>
    
         <p className="pstyle">Generate Invoice</p>
         <p className="pstyle">Invoice Management</p>
         </div>
          </div>
       
          
          <div className="col mt-2 subcription_style"> 
          <div className="col  gold_header_bodaerstyle">
          <div className="gold_style">
            <FontAwesomeIcon icon={faCrown} color="choclate" size="100" />

          </div>
         
          <div className="sub_header">
            <h4>Gold Plan</h4>
            <h4>₹ 2500</h4>
          </div>
          <div className="sub_header">
            <h6>Six Month ,Desktop App</h6>
            <span style={{ textDecoration: 'line-through' }}>₹ 3500</span>
          </div>
          <button onClick={()=>{
            window.open("https://rzp.io/i/hvyzVGm4","_blank")
          }} className="goldbtn">Buy Gold</button>
          </div>
          <div className="cenert-border">
         <p className="pstyle">Your Custom Template </p>
         <p className="pstyle">Inventory Management </p>
    
         <p className="pstyle">Generate Invoice</p>
         <p className="pstyle">Invoice Management</p>
         </div>
          </div>
          </div>
          </div>
          </div>
    )
}